import {
  cn,
  KdsButtonIcon,
  KdsDivider,
  KdsLink,
  KdsText,
} from "@kazaar-platform/design-system";
import { RiArrowDownSLine, RiArrowRightSLine } from "@remixicon/react";

import { type ReactNode } from "react";

interface CollapseSectionProps {
  title: string;
  children: ReactNode;
  isBlock?: boolean;
  variant?: "white" | "grey" | "transparent";
  size?: "small" | "medium";
  isOpen: boolean;
  onOpenChange: () => void;
  link?: string;
  linkAction?: () => void;
}

export const CollapseSection = ({
  title,
  children,
  isBlock,
  variant,
  size,
  isOpen,
  onOpenChange,
  link,
  linkAction,
}: CollapseSectionProps) => {
  // ClassNames
  const classNames = cn(
    "flex flex-col w-full gap-4 bg-white rounded-lg",
    !variant && "bg-white",
    variant === "grey" && "bg-elevation-third",
    variant === "transparent" && "bg-transparent",
    !!isBlock && "p-4"
  );

  return (
    <div className={classNames}>
      <div className="flex items-center gap-2">
        <div className="whitespace-nowrap">
          <KdsText size={size === "medium" ? "subtitle-md" : "subtitle-xs"}>
            {title}
          </KdsText>
        </div>

        <div className="flex-1">
          <KdsDivider />
        </div>

        {!!link && !!linkAction && (
          <div className="min-w-0 max-w-[33%]">
            <KdsLink size="sm" onPress={linkAction} truncate>
              {link}
            </KdsLink>
          </div>
        )}
        <KdsButtonIcon
          icon={isOpen ? RiArrowDownSLine : RiArrowRightSLine}
          variant="outlined"
          size="small"
          color="neutral"
          onPress={onOpenChange}
        />
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};
